export default "__VITE_PUBLIC_ASSET__33747299__"